export const STATUS = Object.freeze({
    ACTIVE: '1',
    UNDER_ANALYSIS: '2',
    DISABLED: '3',
    UNDER_MAINTENANCE: '4'
})